package ru.villawonka.app.platform.platform.model

data class DeviceInfo(
    val deviceName: String?,
    val osName: String?,
    val osVersion: String?,
)
